<template>
  <component
    :is="icon"
    class="icon"
    :color="color ?? undefined"
  />
</template>

<script setup lang="ts">
interface Props {
  icon?: any
  color?: string
  invertColorOnHover?: boolean
}
withDefaults( defineProps<Props>(), {
  color: 'primary',
} )
</script>

<style scoped></style>